import { Box } from '@mui/material';
import { createPortal } from 'react-dom';
import { useFormContext, useWatch } from 'react-hook-form';

import { IntroductionButton } from '@Components/IconButton';
import Introduction from '@Components/Introduction';
import { useDisclosure } from '@hooks/useDisclosure';

export const ESG_PLATFORM_INTRODUCTION_ID = 'esg-platform-introduction';

const EsgPlatformIntroduction = () => {
  const { getValues } = useFormContext();
  const { introduction } = getValues(`esgDataPlatform`) ?? {}; // Waiting type of form provider

  const [isIntroductionOpen, { open, close }] = useDisclosure(!!introduction);

  const esgPlatformIntroductionEl = document.getElementById(
    ESG_PLATFORM_INTRODUCTION_ID
  );

  const [isCompletedEn, isCompletedTh] = useWatch({
    name: ['completedSection.isCompletedEn', 'completedSection.isCompletedTh'],
  });

  return (
    <>
      <IntroductionButton
        onClick={open}
        disabled={isCompletedTh && isCompletedEn}
      />
      {isIntroductionOpen &&
        esgPlatformIntroductionEl &&
        createPortal(
          <Box mt={2}>
            <Introduction
              onDelete={close}
              topic="เปิดเผยข้อมูลเกี่ยวข้องกับการปล่อยก๊าซเรือนกระจกบนระบบ SET ESG Data Platform"
              setOpen={open}
              fieldPath="esgDataPlatform.introduction"
              isCompletedEn={isCompletedEn}
              isCompletedTh={isCompletedTh}
            />
          </Box>,
          esgPlatformIntroductionEl
        )}
    </>
  );
};

export default EsgPlatformIntroduction;
